import React, { forwardRef } from 'react'
import { Box, Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio } from "@mui/material"
import DragAndDrop from "../public/DragAndDrop"
import ExcelTableXLSX from './ExcelTableXLSX'
import ExcelJS from 'exceljs'


function ExcelAddDialog(props: any, ref: any) {
  const [dropedFiles, setDropedFiles] = React.useState<File[]>([])
  const [dropedWorkbook, setDropedWorkbook] = React.useState<ExcelJS.Workbook>(new ExcelJS.Workbook())
  const [AMNBUSChecked, setAMNBUSChecked] = React.useState(false)
  const [MATSUMURAChecked, setMATSUMURAChecked] = React.useState(false)
  const [animalPresaleChecked, setAnimalPresaleChecked] = React.useState(false)
  // const AMNBUSChecked = React.useRef(false)
  const handleFilesChange = (files: File[]) => {
    setDropedFiles(files)
    readXLSX(files[0])
  }

  const readXLSX = async (file: File) => {
    if (file) {
      var reader = new FileReader();
      reader.onload = async (evt: any) => {
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(evt.currentTarget.result)
        analyzeXLSX(workbook)
      }
      reader.readAsArrayBuffer(file);
    } else {
      setDropedWorkbook(new ExcelJS.Workbook())
    }
  }

  const analyzeXLSX = (workbook: ExcelJS.Workbook) => {
    if (workbook) {
      setDropedWorkbook(workbook)
      console.log(JSON.stringify(workbook.worksheets[0].getRow(1).values))
      switch (JSON.stringify(workbook.worksheets[0].getRow(1).values)) {
        case '[null,"AMNBUS_URL","货号","日文名称","中文名称","成本(元/个)","成本(日元/个)","日元售价","代理版(元/个)","日版(元/个)","每盒数量","每箱数量","截单日期","发售日期"]':
          setAMNBUSChecked(true)
          setMATSUMURAChecked(false)
          setAnimalPresaleChecked(false)
          break;
        case '[null,"MATSUMURA_URL","货号","日文名称","中文名称","成本(元/个)","成本(日元/个)","日元售价","代理版(元/个)","日版(元/个)","每盒数量","每箱数量","截单日期","发售日期"]':
          setAMNBUSChecked(false)
          setMATSUMURAChecked(true)
          setAnimalPresaleChecked(false)
          break;
        case '[null,"中文名称","子分类","单价(元/只)","捆绑分类","是否捆绑销售","开启预售","定金比例","截单时间","到货时间"]':
          setAMNBUSChecked(false)
          setMATSUMURAChecked(false)
          setAnimalPresaleChecked(true)
          break;
        default:
          setAMNBUSChecked(false)
          setMATSUMURAChecked(false)
          setAnimalPresaleChecked(false)
      }
    }
  }

  React.useImperativeHandle(ref, () => ({
    getCheckedType: (): string => {
      let type = 'default'
      if (AMNBUSChecked) {
        type = 'AMNBUS'
      }
      if (MATSUMURAChecked) {
        type = 'MATSUMURA'
      }
      if (animalPresaleChecked) {
        type = 'ANIMALPRESALE'
      }
      return type
    }
  }));

  return <Dialog
    fullWidth={true}
    maxWidth='xl'
    open={props.open}
    onClose={props.onClose}
  >
    <DialogTitle>{'批量添加商品'}
      <FormControlLabel
        sx={{ ml: 4 }}
        labelPlacement='end'
        label={"AMNBUS格式"}
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setAMNBUSChecked(event.target.checked)
              setMATSUMURAChecked(false)
              setAnimalPresaleChecked(false)
            }}
            checked={AMNBUSChecked}
          />
        }
      />
      <FormControlLabel
        sx={{ ml: 4 }}
        labelPlacement='end'
        label={"MATSUMURA格式"}
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setAMNBUSChecked(false)
              setMATSUMURAChecked(event.target.checked)
              setAnimalPresaleChecked(false)
            }}
            checked={MATSUMURAChecked}
          />
        }
      />
      <FormControlLabel
        sx={{ ml: 4 }}
        labelPlacement='end'
        label={"动物预售列表格式"}
        control={
          <Checkbox
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setAMNBUSChecked(false)
              setMATSUMURAChecked(false)
              setAnimalPresaleChecked(event.target.checked)
            }}
            checked={animalPresaleChecked}
          />
        }
      />
    </DialogTitle>
    <DialogContent>
      <DragAndDrop
        dropedFiles={dropedFiles}
        setDropedFiles={handleFilesChange}
        accept='.xlsx, .xls'
        multiple={false}
      ></DragAndDrop>

      <ExcelTableXLSX
        AMNBUSChecked={AMNBUSChecked}
        MATSUMURAChecked={MATSUMURAChecked}
        animalPresaleChecked={animalPresaleChecked}
        sheet={dropedWorkbook.worksheets[0]}
        sx={{ my: 2 }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        sx={{ mx: 1 }}
        onClick={() => { props.onClose(false) }}
      >
        {"取消"}
      </Button>

      <Button
        onClick={() => {
          if (window.confirm('确认创建订单？')) {
            let templateError = false
            if (AMNBUSChecked) {
              if (JSON.stringify(dropedWorkbook.worksheets[0].getRow(1).values)
                != '[null,"AMNBUS_URL","货号","日文名称","中文名称","成本(元/个)","成本(日元/个)","日元售价","代理版(元/个)","日版(元/个)","每盒数量","每箱数量","截单日期","发售日期"]') {
                templateError = true
                props.newAlert('模板错误', 'error')
              }
            }

            if (MATSUMURAChecked) {
              if (JSON.stringify(dropedWorkbook.worksheets[0].getRow(1).values)
                != '[null,"MATSUMURA_URL","货号","日文名称","中文名称","成本(元/个)","成本(日元/个)","日元售价","代理版(元/个)","日版(元/个)","每盒数量","每箱数量","截单日期","发售日期"]') {
                templateError = true
                props.newAlert('模板错误', 'error')
              }
            }

            if (animalPresaleChecked) {
              if (JSON.stringify(dropedWorkbook.worksheets[0].getRow(1).values)
                != '[null,"中文名称","子分类","单价(元/只)","捆绑分类","是否捆绑销售","开启预售","定金比例","截单时间","到货时间"]') {
                templateError = true
                props.newAlert('模板错误', 'error')
              }
            }
            if (!templateError) {
              props.onSubmit(dropedWorkbook.worksheets[0])
              setDropedWorkbook(new ExcelJS.Workbook())
              setDropedFiles([])
              props.onClose(false)
            }
          }
        }}
      >
        {"提交"}
      </Button>
    </DialogActions>
  </Dialog>
}

export default forwardRef(ExcelAddDialog)